"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IACContainer = void 0;
const react_1 = __importDefault(require("react"));
const Shared_1 = require("@/components/styled-controls/Shared");
const Layout_1 = __importDefault(require("@/components/organisms/Layout"));
const UserRegistrationContext_1 = require("@/context/UserRegistrationContext");
const constant_1 = require("@/constants/constant");
const styled_components_1 = __importDefault(require("styled-components"));
exports.IACContainer = styled_components_1.default.div `
  margin-top: 42px;
  text-align: center;
`;
const OutlineButton = (0, styled_components_1.default)(Shared_1.StyledButton) `
  background-color: #ffffff;
  color: #007eff !important;
  border: 2px solid #007eff;
`;
const Success = () => {
    const { appProps } = (0, UserRegistrationContext_1.useUserRegistration)();
    const registrationStepCopy = appProps.registrationStepCopy?.SUCCESS?.TITLE || constant_1.HEADER_TEXTS.SUCCESS.TITLE;
    const subHeaderText = appProps.registrationStepCopy?.SUCCESS?.SUBTITLE || constant_1.HEADER_TEXTS.SUCCESS.SUBTITLE;
    return (react_1.default.createElement(Layout_1.default, { registrationStepCopy: registrationStepCopy, subHeaderText: subHeaderText },
        react_1.default.createElement(Shared_1.StyledButton, { forwardedAs: "a", buttonType: "default", href: appProps.trialUrl, dataAnalytics: constant_1.DATA_ANALYTICS_TAG.SUCCESS.EXPLORE_FREE_TRIALS(appProps.analyticsPrefix), size: "m", "$isDisabled": false, id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-explore-free-trials`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-explore-free-trials`, style: { marginBottom: 16 } }, "Explore Free Trials"),
        react_1.default.createElement(OutlineButton, { forwardedAs: "a", buttonType: "default", href: appProps.successContinueUrl, dataAnalytics: constant_1.DATA_ANALYTICS_TAG.SUCCESS.CONTINUE(appProps.analyticsPrefix), size: "m", "$isDisabled": false, id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-finish`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-finish` }, appProps.lastScreenButtonText)));
};
exports.default = Success;
